import React, { useState } from "react";
import "./pstyle.css";
import "../fonts.css";
import { MDBContainer } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import GlobalURL from "../baseUrl";
import Button from "react-bootstrap/Button";
import { RiErrorWarningLine } from "react-icons/ri";
import { RiEyeCloseLine } from "react-icons/ri";
import { AiOutlineEye } from "react-icons/ai";
import { FaLanguage } from "react-icons/fa6";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../redux/languageSlice";
import translations from "../locals/translation";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

function Login() {
  const dispatch = useDispatch();
  const language = useSelector((state) => state.language.value);

  const t = (key) => {
    if (translations[language]) {
      const translation = translations[language][key];
      return translation !== undefined ? translation : key;
    } else {
      return key;
    }
  };

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [showMes, setShowMes] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassWord, setShowPassWord] = useState(false);
  const [validated, setValidated] = useState(false);

  const loginUser = async () => {
    if (email === "" || password === "") {
      setMessage(t("Empty data"));
      setShowMes(true);
      return;
    }
    setShowMes(false);
    setLoading(true);
    try {
      const apiUrl = `${GlobalURL}/api/dev/admin/auth/login`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "69420",
          lang_id: JSON.stringify(language),
        },
        body: JSON.stringify({ username: email, password: password }),
      });
      const data = await response.json();

      if (data.status_code === 200) {
        setMessage(data.message);
        setShowMes(true);
        setLoading(false);
      } else if (data.status_code === 400) {
        setMessage(t("You have entered the wrong username or password"));
        setShowMes(true);
        setLoading(false);
        setValidated(true);
        return false;
      } else if (data.status_code === 403) {
        setMessage(data.message);
        setShowMes(true);
        setLoading(false);
        return false;
      } else if (data.status_code === 500) {
        setMessage(data.message);
        setShowMes(true);
        setLoading(false);
        return false;
      } else {
        setShowMes(true);
        setLoading(false);
        setMessage(t("Server Error!"));
        return false;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("name", data.data[0].first_name);
      localStorage.setItem("lname", data.data[0].last_name);
      localStorage.setItem("uname", data.data[0].email);
      localStorage.setItem("mobile", data.data[0].phone);
      localStorage.setItem("admin_id", data.data[0].id);

      setLoading(false);
      navigate("/dashboard", {state:data.data[0]});
    } catch (error) {
      setShowMes(true);
      setMessage(t(`Server Error!`));
      setLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    loginUser();
    if (loginUser()) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setShowMes(false);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setShowMes(false);
  };

  const changeLanguage = (lang) => {
    dispatch(setLanguage(lang));
  };

  return (
    <React.Fragment>
      {/* <Header /> */}
      <div className="body-container">
        <div className="login-form-outer">
          <div className="logo-in-login">
            <img src="./img/sideLogo.png" alt="logo" />
          </div>

          <div className="language-form">
            <MDBContainer
              className="p-6 my-0 d-flex flex-column w-150"
              id="border-login-form"
            >
              <div className="login-heading">
                <h1>{t("Login")}</h1>
              </div>

              <div className="message-on-login">
                {showMes && <RiErrorWarningLine fill="#dc3545" />}
                <p>{showMes && message}</p>
              </div>

              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group controlId="validationCustomEmail">
                  <Form.Label className="form-heading-login">
                    {" "}
                    {t("Username")}
                  </Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={"text"}
                      className={showMes ? "input-validitity" : ""}
                      placeholder={t("Username")}
                      value={email}
                      onChange={handleEmailChange}
                      aria-describedby="inputGroupPrepend"
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      {t("Please enter your Username")}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                <Form.Group controlId="validationCustomPassword">
                  <Form.Label className="form-heading-login">
                    {t("Password")}
                  </Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      className={showMes ? "input-validitity" : ""}
                      type={showPassWord ? "text" : "password"}
                      placeholder={t("Password")}
                      value={password}
                      onChange={handlePasswordChange}
                      aria-describedby="inputGroupPrepend"
                      required
                    />
                    <div
                      className="password-icon-show"
                      onClick={() => {
                        setShowPassWord(!showPassWord);
                      }}
                    >
                      {showPassWord ? <AiOutlineEye /> : <RiEyeCloseLine />}
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {t("Please enter your password.")}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
                <div className="d-flex justify-content-end mx-3 mb-4">
                  <p
                    className="links-urls"
                    onClick={() => {
                      navigate("/forgetpassword");
                    }}
                  >
                    {t("Forgot password?")}
                  </p>
                </div>
                <Button
                  style={{ width: "100%" }}
                  className="buttons"
                  type="submit"
                >
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="loading-spinner"></div>
                    </div>
                  ) : (
                    t("Login")
                  )}
                </Button>
              </Form>
            </MDBContainer>

            <FormControl
              sx={{ m: 1, minWidth: 120 }}
              className="language-switch-mui"
            >
              <FaLanguage />
              <InputLabel id="demo-simple-select-helper-label">
                {t("Language")}
              </InputLabel>
              <Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                label="Age"
                value={language}
                onChange={(e) => changeLanguage(e.target.value)}
                className="lang-option-mui"
              >
                <MenuItem value="en" disabled={language === "en"}>
                  English
                </MenuItem>
                <MenuItem value="es" disabled={language === "es"}>
                  Español
                </MenuItem>
              </Select>
              <FormHelperText>{t("Choose your language")}</FormHelperText>
            </FormControl>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </React.Fragment>
  );
}

export default Login;
